import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useCallback, useState } from 'react';
import ddt from '@wix/da-ddt';
import { isMultiImageDeviation } from '../../DeviationViews/_helpers';
import { useZoomBiLogger } from '../../DeviationViews/Full/hooks/useZoomBiLogger';
import DesktopMultiArtStage from './DesktopMultiArtStage';
import DesktopSingleArtStage from './DesktopSingleArtStage';
const logger = ddt.createLogger('multifile');
export const DesktopArtStage = (props)=>{
    var _props_deviation_extended_additionalMedia, _props_deviation_extended;
    logger.log('DesktopArtStage, multi_file_deviation');
    const hasAdditionalMedia = (_props_deviation_extended = props.deviation.extended) === null || _props_deviation_extended === void 0 ? void 0 : (_props_deviation_extended_additionalMedia = _props_deviation_extended.additionalMedia) === null || _props_deviation_extended_additionalMedia === void 0 ? void 0 : _props_deviation_extended_additionalMedia.length;
    const shouldRenderMultiImage = isMultiImageDeviation(props.deviation) && hasAdditionalMedia;
    // todo: since this bypasses saga and Image's ZoomModal,
    // work on removing saga if/when multi_file_deviation is merged
    const [zoomedImageSource, setZoomedImageSource] = useState();
    const logZoomBi = useZoomBiLogger(props.deviation);
    const zoomProps = {
        zoomedImageSource,
        isZoomed: !!zoomedImageSource,
        onEnterZoomMode: useCallback((source)=>{
            setZoomedImageSource(source);
            logZoomBi(true);
        }, [
            logZoomBi
        ]),
        onExitZoomMode: useCallback(()=>{
            setZoomedImageSource(undefined);
            logZoomBi(false);
        }, [
            logZoomBi
        ])
    };
    return shouldRenderMultiImage ? /*#__PURE__*/ React.createElement(DesktopMultiArtStage, _object_spread({}, props, zoomProps)) : /*#__PURE__*/ React.createElement(DesktopSingleArtStage, _object_spread({}, props, zoomProps));
};
DesktopArtStage.displayName = 'DesktopArtStage';
export default DesktopArtStage;

//# sourceMappingURL=DesktopArtStage.js.map